export const enUS = {
  'We provide a demo for you to try out the features. You can start a one-to-one chat or group chat. Let us chat!': 'We provide a demo for you to try out the features. You can start a one-to-one chat or group chat. Let us chat!',
  'Please note that by using this demo, we will process your personal data in accordance with our Tencent Cloud': 'Please note that by using this demo, we will process your personal data in accordance with our Tencent Cloud',
  'Privacy Policy': 'Privacy Policy',
  'Welcome to': 'Welcome to',
  'chats': 'chats',
  'contacts': 'contacts',
  'Recommended Demo Features': 'Recommended Demo Features',
  'Send a message': 'Send a message',
  'Recall a message': 'Recall a message',
  'Start a Chat': 'Start a Chat',
  'Delete a chat': 'Delete a chat',
  'Create a group chat': 'Create a group chat',
  'Get Started - Run a Demo': 'Get Started - Run a Demo',
  'Completed': 'Completed',
  'Not tried yet': 'Not tried yet',
  'Tencent Cloud': 'Tencent Cloud',
  'Chat': 'Chat',
  'Free Trial': 'Free Trial',
  'Get Started': 'Get Started',
  'Developer Group': 'Developer Group',
  'Join': 'Join',
  'Details': 'Details',
  'Follow': 'Follow',
  'Subscribe': 'Subscribe',
  'Give a like': 'Give a like',
  'Give a reward': 'Give a reward',
  'See the participants': 'See the participants',
  'Ask a question': 'Ask a question',
  'Feedback to a reply': 'Feedback to a reply'
}